import React from 'react';
import { useParams, Link } from 'react-router-dom';

// Components
import FlexContainer from 'components/FlexContainer/FlexContainer';
import ProgressCircle from 'components/ProgressCircle/ProgressCircle';
// import BoxBasic from 'components/Box/BoxBasic/BoxBasic';
import CardSolid from 'components/Card/CardSolid/CardSolid';
// import Boxes from 'components/Box/Boxes';
// import Thumbnail from 'components/Thumbnail/Thumbnail';
// import Button from 'components/Button/Button';

// Styles
import styles from './ProjectInformation.module.scss';
// import boxBasicStyles from 'components/Box/BoxBasic/BoxBasic.module.scss';

import { useQuery } from 'react-query';
import instance from 'axiosInstance';

const ProjectInformation = () => {
  const { slug } = useParams();

  const getProjectInformation = async ({ queryKey }) => {
    const response = await instance.get('/private/projects/' + queryKey[1]);
    return response.data;
  };

  const { data } = useQuery(['projects', slug], getProjectInformation);

  const { po, pm, project, retainer, pmTime, qaTime, devTime } = data[0];

  return (
    <CardSolid
      title={<span className={styles['project-title']}>{project.name}</span>}
    >
      <FlexContainer
        justify="justify-between"
        align="align-center"
        spaceY="space-y-1-75em"
        wrap="wrap"
      >
        <div className={styles['project-items']}>
          <FlexContainer justify="justify-between">
            <div className={styles['cell']}>
              <span className={styles['label']}>Retainer plan: </span>
              <span className={styles['value']}>{`${retainer}h`}</span>
            </div>
            <div className={styles['cell']}>
              <span className={styles['label']}>Project Owner: </span>
              <Link to={`/member/${po.slug}`} className={styles['value']}>
                {po.name}
              </Link>
            </div>
            <div className={styles['cell']}>
              <span className={styles['label']}>Project Manager: </span>
              <Link to={`/member/${pm.slug}`} className={styles['value']}>
                {pm.name}
              </Link>
            </div>
          </FlexContainer>
        </div>
        <FlexContainer>
          <FlexContainer
            align="align-center"
            justify="justify-center"
            spaceX="space-x-5px"
          >
            <ProgressCircle progress={pmTime} text="PM" />
          </FlexContainer>
          <FlexContainer
            align="align-center"
            justify="justify-center"
            spaceX="space-x-5px"
          >
            <ProgressCircle progress={devTime} text="Dev" />
          </FlexContainer>
          <FlexContainer
            align="align-center"
            justify="justify-center"
            spaceX="space-x-5px"
          >
            <ProgressCircle progress={qaTime} text="QA" />
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </CardSolid>
  );
};

export default ProjectInformation;
